export default {
    searchSuggestion: 'Search by Employee No or Name',
    search: 'Search',
    startDate: 'Start Date',
    endDate: 'End Date',
    employeeNo: 'Employee No',
    employeeName: 'Employee Name',
    date: 'Date',
    time: 'Time',
    exportExcel: 'Export Excel',
    exportPdf: 'Export PDF',
    hasNoPermission: 'This function is not available for your shift type'
}
